import { SectionsInterface } from '../../field.interface';

export class Room32Layout {
	sections: SectionsInterface[] = [
		{
			title: 'Room',
			items: [
				[
					{
						cssClass: 'col-md-6',
						options: {
							path: 'InspectionReport.property.rooms[{index}].roomType',
							label: 'Room Type'
						}
					},
				],
				[
					{
						cssClass: 'col-md-12',
						options: {
							path: 'InspectionReport.property.rooms[{index}].otherDescription',
							label: 'Please uniquely name your room'
						}
					}
				]
			]
		}
	];
}
